import { MenuOption } from "./Default"

/**功能类 */
class FunctionItem{
  constructor(type, text, id, obj = { underline: false, isNew: false }) {
    /**类型 */
    this.type = type
    /**显示文本 */
    this.text = text
    /**唯一ID */
    this.id = Symbol(id)
    /**下划线 */
    this.underline = obj.underline ? obj.underline : false
    /**是否为新功能 */
    this.isNew = obj.isNew ? obj.isNew : false
  }
}

/**三级菜单列表类 */
class SummaryMenuOptionThird extends MenuOption{
  constructor(name, id, obj = { num: null, title: '', icon: ''}) {
    super(name, id)
    /**数据数量 */
    this.num = obj.num != null ? obj.num : null
    /**图标 */
    this.icon = obj.icon ? obj.icon : ''
    /**标题 */
    this.title = obj.title ? obj.title : ''
    /**是否被选中 */
    this.isSelect = false
    /**是否显示 */
    this.isShow = true
  }
}

/**二级菜单列表类 */
class SummaryMenuOptionBySecond extends MenuOption{
  constructor(name, id, list) {
    super(name, id)
    /**列表 */
    this.list = list
  }
}

/**一级菜单列表类 */
class SummaryMenuOptionByFrist extends SummaryMenuOptionThird{
  constructor(name, id, list) {
    super(name, id)
    /**列表 */
    this.list = list
  }
}

/**标签类 */
class summaryTab extends MenuOption{
  constructor(name, id){
    super(name, id)
  }
}

/**汇总页面新建模块 */
class SummaryNewModule{
  /**常用功能 */
  static NEWFUNCTIONLIST(){
    let arr = [
      new FunctionItem('root', '切换为店铺授权版', 'root', { underline:true }),
      new FunctionItem('dialog', '使用操作说明', 'manual'),
      new FunctionItem('page', '选品利润预算', 'profitBudget', { isNew:true }),
      new FunctionItem('page', '跨境物流计价及订购', 'logisticsPricing', { isNew:true }),
      new FunctionItem('page', 'FBA发补货计划', 'FBAReplenishmentPlan'),
      new FunctionItem('page', '上传汇总报告数据', 'uploadReport'),
    ]
    return arr
  }
  /**左侧菜单列表 */
  static NEWFUNCTIONMENU(){
    /**店铺账户初始设置 */
    let shopAccountSettingsObj = {
      shopExpenseSettings: new SummaryMenuOptionThird('店铺及费用设置', 'shopExpenseSettings'),
      salesCommissionSetting: new SummaryMenuOptionThird('商品销售提成设置', 'salesCommissionSetting'),
      taxRateSetting: new SummaryMenuOptionThird('商品开票税率及退税率设置', 'taxRateSetting'),
      summaryDateSetting: new SummaryMenuOptionThird('每月汇总日期设置', 'summaryDateSetting'),
    }
    /**每月汇总 */
    let monthlySummaryObj = {
      summaryDashboard: new SummaryMenuOptionThird('汇总看板', 'summaryDashboard'),
      uploadSummaryReport: new SummaryMenuOptionThird('上传汇总数据报告', 'uploadSummaryReport'),
    }
    /**产品管理 */
    let productManagementObj = {
      newProductInfo: new SummaryMenuOptionThird('新建产品信息', 'newProductInfo'),
      productInfo: new SummaryMenuOptionThird('产品管理', 'productInfo', { num: 0 }),
    }
    /**销售信息管理 */
    let salesInformationObj = {
      newListing: new SummaryMenuOptionThird('新建商品Listing', 'newListing'),
      listing: new SummaryMenuOptionThird('商品Listing管理', 'listing', { num: 0 }),
    }
    /**储备管理 */
    let reservesObj = {
      newFBAReplenishment: new SummaryMenuOptionThird('新建FBA发补货计划', 'newFBAReplenishment', { title: '亚马逊店铺发补货' }),
      FBAReplenishment: new SummaryMenuOptionThird('FBA发补货计划单', 'FBAReplenishment', { num: 0 }),
      productReserves: new SummaryMenuOptionThird('新建产品储备计划', 'newProductReserves', { title: '成品仓产品储备' }),
      newProductReserves: new SummaryMenuOptionThird('产品储备计划单', 'productReserves'),
    }
    /**销售状况 */
    let salesSituationObj = {
      orderQuantity: new SummaryMenuOptionThird('订单数量', 'orderQuantity'),
      productSales: new SummaryMenuOptionThird('商品销量', 'productSales'),
      salesTrendAnalysis: new SummaryMenuOptionThird('销售趋势分析', 'salesTrendAnalysis'),
    }
    /**售后管理 */
    let afterSalesObj = {
      returnOrder: new SummaryMenuOptionThird('退货单', 'returnOrder'),
      swapOrder: new SummaryMenuOptionThird('换货单', 'swapOrder'),
      removeOrder: new SummaryMenuOptionThird('移除单', 'removeOrder'),
      discardOrder: new SummaryMenuOptionThird('弃置单', 'discardOrder'),
    }
    /**利润动态分析 */
    let profitAnalysisObj = {
      profitFromProductSelection: new SummaryMenuOptionThird('选品利润预算', 'profitFromProductSelection', { num: 0, title: '预选商品(选品利润分析)' }),
      productSelectionCost: new SummaryMenuOptionThird('预选商品成本与费用', 'productSelectionCost'),
      productProfit: new SummaryMenuOptionThird('在售商品与店铺利润核算', 'productProfit', { num: 0, title: '在售商品及店铺(售后利润核算)' }),
      costOfGoods: new SummaryMenuOptionThird('在售商品成本与费用', 'costOfGoods'),
    }
    /**商品核心运营数据分析 */
    let dataAnalysisObj = {
      trafficAndReview: new SummaryMenuOptionThird('流量,订单量,排名,Review等', 'trafficAndReview'),
      advertisingAndSalesNum: new SummaryMenuOptionThird('广告费,库存量,退货量,销量', 'advertisingAndSalesNum'),
    }
    /**站外推广及其他站外服务 */
    let offSiteServicesObj = {
      newServiceSupplier: new SummaryMenuOptionThird('新建服务供应商', 'newServiceSupplier'),
      serviceSupplierInfo: new SummaryMenuOptionThird('服务供应商信息', 'serviceSupplierInfo', { num: 0 }),
      applicationForExternalExpenses: new SummaryMenuOptionThird('商品站外推广费用申请', 'applicationForExternalExpenses', { num: 0 }),
    }
    /**广告活动 */
    let advertisingCampaignObj = {
      advertisingOverview: new SummaryMenuOptionThird('广告概览', 'advertisingOverview'),
      advertisingAnalysis: new SummaryMenuOptionThird('广告分析(按ASIN)', 'advertisingAnalysis'),
    }
    /**邮件活动 */
    let emailActivityObj = {
      emailCampaignManagement: new SummaryMenuOptionThird('邮件活动管理', 'emailCampaignManagement'),
      emailTemplateManagement: new SummaryMenuOptionThird('邮件模板管理', 'emailTemplateManagement'),
      requestForEvaluationAnalysis: new SummaryMenuOptionThird('索评效果分析', 'requestForEvaluationAnalysis'),
    }
    /**产品供应商管理 */
    let supplierManagementObj = {
      newProductSupplier: new SummaryMenuOptionThird('新建产品供应商', 'newProductSupplier'),
      productSupplierInfo: new SummaryMenuOptionThird('产品供应商信息', 'productSupplierInfo', { num: 0 }),
    }
    /**产品采购管理 */
    let procurementManagementObj = {
      purchaserInformation: new SummaryMenuOptionThird('采购方信息', 'purchaserInformation'),
      purchasePlanSheet: new SummaryMenuOptionThird('采购计划单', 'purchasePlanSheet', { num: 0 }),
      purchaseOrderToBeSupplemented: new SummaryMenuOptionThird('待补充采购单', 'purchaseOrderToBeSupplemented', { num: 0 }),
      purchaseOrder: new SummaryMenuOptionThird('采购单', 'purchaseOrder'),
    }
    /**中转仓库管理 */
    let transitWarehouseManagementObj = {
      newWarehouse: new SummaryMenuOptionThird('新建中转仓库', 'newWarehouse'),
      repositoryList: new SummaryMenuOptionThird('中转仓库列表', 'repositoryList'),
    }
    /**出入仓管理 */
    let warehouseEntryAndExitManagementObj = {
      warehouseRegistration: new SummaryMenuOptionThird('入仓登记', 'warehouseRegistration', { num: 0 }),
      outboundRegistration: new SummaryMenuOptionThird('出仓登记', 'outboundRegistration', { num: 0 }),
      deliveryTask: new SummaryMenuOptionThird('发货任务', 'deliveryTask', { num: 0 }),
      warehouseReceipt: new SummaryMenuOptionThird('入仓单', 'warehouseReceipt'),
      deliveryOrder: new SummaryMenuOptionThird('出仓单', 'deliveryOrder'),
    }
    /**库存状况 */
    let inventoryStatusObj = {
      productReserveInventory: new SummaryMenuOptionThird('产品储备库存量', 'productReserveInventory'),
      amazonProductInventory: new SummaryMenuOptionThird('亚马逊商品库存量', 'amazonProductInventory'),
      totalInventory: new SummaryMenuOptionThird('产品/商品总库存量', 'totalInventory'),
    }
    /**物流信息预设置 */
    let logisticsInformationPresettingObj = {
      senderInformation: new SummaryMenuOptionThird('寄件人信息', 'senderInformation'),
      recipientInformation: new SummaryMenuOptionThird('收件人信息', 'recipientInformation'),
      insuredPersonInformation: new SummaryMenuOptionThird('被保人信息', 'insuredPersonInformation'),
      customsBrokerageInformation: new SummaryMenuOptionThird('报关代理信息', 'customsBrokerageInformation'),
      billOfLadingInformation: new SummaryMenuOptionThird('订舱及提单信息', 'billOfLadingInformation'),
      customsDeclarationDocuments: new SummaryMenuOptionThird('清关报关资料', 'customsDeclarationDocuments'),
      billingInformation: new SummaryMenuOptionThird('开票信息', 'billingInformation'),
    }
    /**跨境物流管理 */
    let crossBorderLogisticsManagementObj = {
      logisticsPricing: new SummaryMenuOptionThird('跨境物流计价及发货计划', 'logisticsPricing', { title: '发货计划单' }),
      pendingLogisticsOrders: new SummaryMenuOptionThird('待完成的物流预订', 'pendingLogisticsOrders', { num: 0, title: '发货单' }),
      unpaidLogisticsOrders: new SummaryMenuOptionThird('未支付的物流订单', 'unpaidLogisticsOrders', { num: 0 }),
      theLogisticsOrderHasBeenPaid: new SummaryMenuOptionThird('已支付的物流订单及跟踪', 'theLogisticsOrderHasBeenPaid', { num: 0 }),
    }
    /**权限设置 */
    let permissionSettingsObj = {
      jobAuthoritySetting: new SummaryMenuOptionThird('岗位权限设置', 'jobAuthoritySetting'),
    }
    /**请款审批与运营成本管理 */
    let operationalCostManagementObj = {
      approvalOfOperatingExpenses: new SummaryMenuOptionThird('商品"站外"运营费用审批', 'approvalOfOperatingExpenses', { num: 0 }),
      monthlyManagementFee: new SummaryMenuOptionThird('每月管理及人力成本更新', 'monthlyManagementFee'),
    }
    /**财务状况汇总 */
    let financialSummaryObj = {
      assetSummary: new SummaryMenuOptionThird('资产汇总', 'assetSummary'),
      accountsPayable: new SummaryMenuOptionThird('应付款', 'accountsPayable', { num: 0 }),
      accountsReceivable: new SummaryMenuOptionThird('应收款', 'accountsReceivable', { num: 0 }),
      paymentAndReceiptDetails: new SummaryMenuOptionThird('收付款明细', 'paymentAndReceiptDetails'),
      netProfitOfTheCompany: new SummaryMenuOptionThird('商品,店铺及公司净利润', 'netProfitOfTheCompany'),
      productInventoryValue: new SummaryMenuOptionThird('储备产品库存价值', 'productInventoryValue'),
      commodityInventoryValue: new SummaryMenuOptionThird('亚马逊商品库存价值', 'commodityInventoryValue'),
      totalInventoryValue: new SummaryMenuOptionThird('产品/商品总库存价值', 'totalInventoryValue'),
    }
    /**每月成本与费用 */
    let monthlyCostObj = {
      intraSiteCostOfGoods: new SummaryMenuOptionThird('商品当月"站内"成本与费用', 'intraSiteCostOfGoods', { title: '商品' }),
      externalCostOfMerchandise: new SummaryMenuOptionThird('商品当月"站外"成本与费用', 'externalCostOfMerchandise'),
      inStoreCostOfTheShop: new SummaryMenuOptionThird('店铺当月"站内"成本与费用', 'inStoreCostOfTheShop', { title: '店铺' }),
      costsOutsideTheStore: new SummaryMenuOptionThird('店铺当月"站外"成本与费用', 'costsOutsideTheStore'),
    }
    /**财务月报表 */
    let monthlyFinancialReportObj = {
      inSiteCostReportOfGoods: new SummaryMenuOptionThird('商品"站内"成本与费用报表', 'inSiteCostReportOfGoods'),
      commodityOffSiteCostReport: new SummaryMenuOptionThird('商品"站外"成本与费用报表', 'commodityOffSiteCostReport'),
      storeInternalCostReport: new SummaryMenuOptionThird('店铺"站内"成本与费用报表', 'storeInternalCostReport'),
      storeOffSiteCostReport: new SummaryMenuOptionThird('店铺"站外"成本与费用报表', 'storeOffSiteCostReport'),
      operatingExpenseReport: new SummaryMenuOptionThird('公司或个人运费用报表', 'operatingExpenseReport'),
      assetSummaryReport: new SummaryMenuOptionThird('资产汇总报表', 'assetSummaryReport'),
    }
    /**设置 */
    let settingObj = {
      shopAccountSettings: new SummaryMenuOptionBySecond('店铺账户初始设置', 'shopAccountSettings', shopAccountSettingsObj)
    }
    /**汇总 */
    let summaryObj = {
      monthlySummary: new SummaryMenuOptionBySecond('每月汇总', 'monthlySummary', monthlySummaryObj)
    }
    /**产品 */
    let productObj = {
      supplierManagement: new SummaryMenuOptionBySecond('产品供应商管理', 'supplierManagement', supplierManagementObj),
      productManagement: new SummaryMenuOptionBySecond('产品管理', 'productManagement', productManagementObj)
    }
    /**销售 */
    let saleObj = {
      salesInformation: new SummaryMenuOptionBySecond('销售信息管理', 'salesInformation', salesInformationObj),
      salesSituation: new SummaryMenuOptionBySecond('销售状况', 'salesSituation', salesSituationObj),
      afterSales: new SummaryMenuOptionBySecond('售后管理', 'afterSales', afterSalesObj),
    }
    /**运营 */
    let operateObj = {
      profitAnalysis: new SummaryMenuOptionBySecond('利润动态分析', 'profitAnalysis', profitAnalysisObj),
      reserves: new SummaryMenuOptionBySecond('储备管理', 'reserves', reservesObj),
      dataAnalysis: new SummaryMenuOptionBySecond('商品核心运营数据分析(按ASIN)', 'dataAnalysis', dataAnalysisObj),
      offSiteServices: new SummaryMenuOptionBySecond('站外推广及其他站外服务', 'offSiteServices', offSiteServicesObj),
      advertisingCampaign: new SummaryMenuOptionBySecond('广告活动', 'advertisingCampaign', advertisingCampaignObj),
      emailActivity: new SummaryMenuOptionBySecond('邮件活动', 'emailActivity', emailActivityObj),
    }
    /**采购 */
    let purchaseObj = {
      procurementManagement: new SummaryMenuOptionBySecond('产品采购管理', 'procurementManagement', procurementManagementObj),
    }
    /**仓储 */
    let warehousingObj = {
      transitWarehouseManagement: new SummaryMenuOptionBySecond('中转仓库管理', 'transitWarehouseManagement', transitWarehouseManagementObj),
      warehouseEntryAndExitManagement: new SummaryMenuOptionBySecond('出入仓管理', 'warehouseEntryAndExitManagement', warehouseEntryAndExitManagementObj),
      inventoryStatus: new SummaryMenuOptionBySecond('库存状况', 'inventoryStatus', inventoryStatusObj),
    }
    /**仓储 */
    let logisticsObj = {
      logisticsInformationPresetting: new SummaryMenuOptionBySecond('物流信息预设置', 'logisticsInformationPresetting', logisticsInformationPresettingObj),
      crossBorderLogisticsManagement: new SummaryMenuOptionBySecond('跨境物流管理', 'crossBorderLogisticsManagement', crossBorderLogisticsManagementObj),
    }
    /**财务 */
    let financeObj = {
      permissionSettings: new SummaryMenuOptionBySecond('权限设置', 'permissionSettings', permissionSettingsObj),
      operationalCostManagement: new SummaryMenuOptionBySecond('请款审批与运营成本管理', 'operationalCostManagement', operationalCostManagementObj),
      financialSummary: new SummaryMenuOptionBySecond('财务状况汇总', 'financialSummary', financialSummaryObj),
      monthlyCost: new SummaryMenuOptionBySecond('每月成本与费用', 'monthlyCost', monthlyCostObj),
      monthlyFinancialReport: new SummaryMenuOptionBySecond('财务月报表', 'monthlyFinancialReport', monthlyFinancialReportObj),
    }
    let obj = {
      setting : new SummaryMenuOptionByFrist('设置', 'setting', settingObj),
      summary : new SummaryMenuOptionByFrist('汇总', 'summary', summaryObj),
      product : new SummaryMenuOptionByFrist('产品', 'product', productObj),
      sale : new SummaryMenuOptionByFrist('销售', 'sale', saleObj),
      operate : new SummaryMenuOptionByFrist('运营', 'operate', operateObj),
      purchase : new SummaryMenuOptionByFrist('采购', 'purchase', purchaseObj),
      warehousing : new SummaryMenuOptionByFrist('仓储', 'warehousing', warehousingObj),
      logistics : new SummaryMenuOptionByFrist('物流', 'logistics', logisticsObj),
      finance : new SummaryMenuOptionByFrist('财务', 'finance', financeObj),
    }
    return obj
  }
  /**用户菜单 */
  static NEWUSERMENU(){
    let arr = [
      new SummaryMenuOptionThird('帐户设置', 'account', { icon: 'el-icon-finished' }),
      new SummaryMenuOptionThird('续费', 'renew', { icon: 'el-icon-view' }),
      new SummaryMenuOptionThird('支付记录', 'payment', { icon: 'el-icon-edit-outline' }),
      new SummaryMenuOptionThird('上级汇报设置', 'report', { icon: 'el-icon-headset' }),
    ]
    return arr
  }
  /**动态组件默认参数 */
  static DEFAULTARGUMENT(){
    let obj = {
      newProductInfo: { type: 'new', id: null },
      newListing: { type: 'new', id: null }
    }
    return obj
  }
}

export{
  SummaryNewModule, summaryTab
}
